import { NgModule } from '@angular/core';
import { HelpComponent } from './help/help';
import { CommonModule } from '@angular/common';
@NgModule({
	declarations: [HelpComponent],
	imports: [CommonModule],
	exports: [HelpComponent]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts